/* eslint-disable import/order */
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import reportWebVitals from 'src/reportWebVitals';
import * as Sentry from '@sentry/browser';
import { AppWrapper } from 'src/app';
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css';
import 'react-toastify/dist/ReactToastify.css';
import './index.css';
import 'src/asset/scss/global.scss';
import { config } from 'src/util/config';
/* eslint-enable import/order */

const { sentry: sentryConfig } = config();
if (sentryConfig)
	Sentry.init({
		environment: window.location.host,
		dsn: sentryConfig.dsn,
		integrations: [new Sentry.BrowserTracing(), new Sentry.Replay({ maskAllText: true, blockAllMedia: true })],
		tracesSampleRate: sentryConfig.sampleRate,
		replaysSessionSampleRate: sentryConfig.replaysSessionSampleRate,
		replaysOnErrorSampleRate: sentryConfig.replaysOnErrorSampleRate,
	});

ReactDOM.render(
	<React.StrictMode>
		<BrowserRouter basename={`${process.env.PUBLIC_URL}`}>
			<AppWrapper />
		</BrowserRouter>
	</React.StrictMode>,
	document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
